<ng-container *transloco="let t">
<div class="success-message">
  <div class="card">
    <div class="card-body">
      <div class="card-px text-center py-20 my-10">
        <h2 class="fs-2x fw-bold mb-10">{{ t('portal.eSign.eSignDocument') }}</h2>
        <p class="fs-4 fw-semibold mb-10 success-text">
          {{ t('portal.eSign.successMessage') }}
        </p>
        <a class="btn btn-lg btn-primary">{{ t('portal.eSign.goingBackToLoan') }}
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </a>
      </div>
    </div>
  </div>
</div>
</ng-container>
